import * as React from 'react';
import { withTranslation } from 'react-i18next';
import FinancingStatusBadge from './financing/FinancingStatusBadge';

const SveaFinancingStatusBadge = ({ status, t, size = 'small' }) => {
  if (!status) {
    return null;
  }

  const getLabel = () => {
    switch (status) {
      case 'created':
        return t('svea.statusCreated', 'Rahoituslinkki luotu');
      case 'pending':
        return t('svea.statusPending', 'Odottaa asiakasta');
      case 'paid':
        return t('svea.statusPaid', 'Rahoitettu');
      case 'delivery_required':
        return t('svea.statusDeliveryRequired', 'Odottaa vahvistusta');
      case 'settled':
        return t('svea.statusSettled', 'Tilitys tehty');
      case 'cancelled':
        return t('svea.statusCancelled', 'Rahoitus peruutettu');
      case 'error':
        return t('svea.statusError', 'Rahoitusvirhe');
      case 'denied':
        return t('svea.statusDenied', 'Rahoitus hylätty');
      case 'refunded':
        return t('svea.statusRefunded', 'Rahoitus hyvitetty');
      default:
        return status;
    }
  };

  return <FinancingStatusBadge status={status} label={getLabel()} size={size} />;
};

export default withTranslation()(SveaFinancingStatusBadge);
